import { memo } from 'react';
import useTween from './useTween';

function AnimatedNumber({ value, format }) {
    const tweened = useTween(Number(value) || 0);

    return <span className='corp-dash__num'>{format(Math.round(tweened))}</span>;
}

export default memo(AnimatedNumber);
